import Vue from 'vue'

export default {
  state: {
    default_colors: {
      'color-primary': '#d92641',
      'color-secondary': '#f56600',
      'color-tertiary': '#00858a',
      'color-light-border': '#EDEFF4',
      'color-font-color': '#3D3F43',
      'color-light-font': '#A19D97',
      'color-success-color': '#399D4D',
      'color-warning-color': '#FDB32B',
      'color-dark-border': '#D4DAE5',
      'color-black': '#000000',
      'color-white': '#ffffff',
      'color-footer': '#3d3f43',
    },
    current_colors: {},
  },
  mutations: {
    SET_DOMAIN_BASED_COLORS: (state, current_brand) => {
      if (current_brand) {
        Vue.set(
          state.current_colors,
          'color-primary',
          current_brand['website_color-primary']
        )
        Vue.set(
          state.current_colors,
          'color-secondary',
          current_brand['website_color-secondary']
        )
        Vue.set(
          state.current_colors,
          'color-tertiary',
          current_brand['website_color-tertiary']
        )
        Vue.set(
          state.current_colors,
          'color-light-border',
          current_brand['website_color-light-border']
        )
        Vue.set(
          state.current_colors,
          'color-font-color',
          current_brand['website_color-font-color']
        )
        Vue.set(
          state.current_colors,
          'color-light-font',
          current_brand['website_color-light-font']
        )
        Vue.set(
          state.current_colors,
          'color-success-color',
          current_brand['website_color-success-color']
        )
        Vue.set(
          state.current_colors,
          'color-warning-color',
          current_brand['website_color-warning-color']
        )
        Vue.set(
          state.current_colors,
          'color-dark-border',
          current_brand['website_color-dark-border']
        )
        Vue.set(
          state.current_colors,
          'color-black',
          current_brand['website_color-black']
        )
        Vue.set(
          state.current_colors,
          'color-white',
          current_brand['website_color-white']
        )
        Vue.set(
          state.current_colors,
          'color-footer',
          current_brand['website_color-footer']
        )
      } else {
        state.current_colors = state.default_colors
      }
    },
  },
  getters: {
    current_colors: state => state.current_colors,
    default_colors: state => state.default_colors,
  },
}
